import { Link as RouterLink } from "react-router-dom";

export default function Link({ children, to, ...otherProps }) {
  return <RouterLink to={to} {...otherProps}>{children}</RouterLink>;
}